const styles = {
    caption: {},
    caption__1: {},
    caption__2: {},
};
export default styles;
